import React, { useState, useContext } from "react";
import SidenavBar from "../shared/SideNavbar";
import Topbar from "../shared/Topbar";
import MainContent from "../shared/MainContent";
import "../style/pages/AdminHomePage.css"; // Reusing admin styles for consistency
import { AuthContext } from "../context/AuthContext";
import { useNavigate, useLocation } from "react-router-dom";

const UserHomePage = () => {
  const [isMenuActive, setMenuActive] = useState(false);
  const [selectedPage, setSelectedPage] = useState("dashboard");
  const { logoutUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();

  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get("page");
    if (page) {
      setSelectedPage(page);
    } else if (!selectedPage) {
      setSelectedPage("dashboard");
    }
  }, [location.search, selectedPage]);

  const userMenuItems = [
    { key: "dashboard", title: "Dashboard", icon: "fa-solid fa-chart-line" },
    { key: "tree_view", title: "Tree View", icon: "fa-solid fa-sitemap" },
    { key: "profile", title: "Profile", icon: "fa-solid fa-user-gear" },
    { key: "view_asset", title: "My Assets", icon: "fa-solid fa-boxes-stacked" },
    { key: "home", title: "Scan QR", icon: "fa-solid fa-qrcode" },
    { key: "view_location", title: "Locations", icon: "fa-solid fa-map-location-dot" },
    { key: "tags", title: "Tags", icon: "fa-solid fa-tags" },
    { key: "activity_log", title: "Activity Log", icon: "fa-solid fa-clock-rotate-left" },
    { key: "logout", title: "Sign Out", icon: "fa-solid fa-sign-out-alt" },
  ];

  const toggleMenu = () => {
    setMenuActive(!isMenuActive);
  };

  const handleMenuClick = (page) => {
    if (page === "logout") {
      logoutUser();
      navigate("/");
      return;
    }
    // Clear query parameters when manually selecting a page
    navigate(location.pathname, { replace: true });
    setSelectedPage(page);
  };

  return (
    <div>
      <SidenavBar
        className={isMenuActive ? "active" : ""}
        toggleMenu={toggleMenu}
        handleMenuClick={handleMenuClick}
        menuItems={userMenuItems}
      />
      <div className={isMenuActive ? "main active" : "main"}>
        <Topbar toggleMenu={toggleMenu} className={isMenuActive ? "active" : ""} menuItems={userMenuItems} handleMenuClick={handleMenuClick} />
        <MainContent selectedPage={selectedPage} className={isMenuActive ? "active" : ""} />
      </div>
    </div>
  );
};
export default UserHomePage;
